//https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
export const EMAIL_MAXIMUM_LENGTH = 254
export const EMAIL_MAXIMUM_LENGTH_ERROR_MESSAGE =
	"Please enter a valid email address (maximum 254 characters)."

export const domainValidationRegex =
	/^(?!@)(?!-)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/ //? to check email domain after @, allows nana.com.br, company.co.uk, etc.

// A typing burst can produce several snapshots in minutes, so a tight cap evicts
// the history you need to recover from a bad overwrite.
export const MAX_VERSIONS_PER_CHANGELOG = 50
export const MAX_VERSIONS_PER_ARTICLE = 50
